import * as React from 'react';

/**
 * DISCLAIMER: This component was created as a standalone billing card due to difficulties
 * using the existing ui/Card component for the billing page styling requirements.
 *
 * TODO: This approach will need to be revisited in the future. We should introduce a more
 * dynamic card component that can accommodate different styling variants (billing, default,
 * etc.) rather than maintaining separate card implementations.
 */

/** Billing page color tokens - extracted from BillingUnified */
const BILLING_STYLES = {
  cardBg: 'bg-[#221F1F]',
  cardBorder: 'border-[#504A4A]',
  headerBorder: 'border-b border-[#504A4A]',
  titleText: 'text-base font-semibold text-[#EBFFEE]',
  primaryText: 'text-[#EBFFEE]',
  secondaryText: 'text-[#A9A3A3]',
  accentText: 'text-[#9B1421]',
  rowHover: 'hover:bg-white/[0.02] transition-colors',
  divider: 'border-[#504A4A]/50',
  dividerLight: 'border-[#504A4A]/30',
} as const;

/** Base card structure - matches ui/Card (rounded-xl border shadow) with billing styling */
const BillingCard = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`rounded-xl border shadow ${BILLING_STYLES.cardBg} ${BILLING_STYLES.cardBorder} text-[#EBFFEE] ${className ?? ''}`}
    {...props}
  />
));
BillingCard.displayName = 'BillingCard';

const BillingCardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`flex items-center justify-between p-4 ${BILLING_STYLES.headerBorder} ${className ?? ''}`}
    {...props}
  />
));
BillingCardHeader.displayName = 'BillingCardHeader';

const BillingCardTitle = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={`${BILLING_STYLES.titleText} flex items-center gap-2 ${className ?? ''}`}
    {...props}
  />
));
BillingCardTitle.displayName = 'BillingCardTitle';

const BillingCardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={`p-0 ${className ?? ''}`} {...props} />
));
BillingCardContent.displayName = 'BillingCardContent';

export {
  BillingCard,
  BillingCardHeader,
  BillingCardTitle,
  BillingCardContent,
  BILLING_STYLES,
};
